export const permissionsFormName = 'tournamentPermissions';
export const SET_TOURNAMENT_MANAGER_EDITING = "SET_TOURNAMENT_MANAGER_EDITING";
export const SET_TOURNAMENT_MANAGERS_IN_STATE = "SET_TOURNAMENT_MANAGERS_IN_STATE";
export const SET_TOURNAMENT_ADMINISTRATOR_EDITING = "SET_TOURNAMENT_ADMINISTRATOR_EDITING";
export const SET_TOURNAMENT_ADMINISTRATORS_IN_STATE = "SET_TOURNAMENT_ADMINISTRATORS_IN_STATE";



// WEBPACK FOOTER //
// ./src/features/tournament/permissions/constants.js